(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["furly-hero-slider"] && !Shopify.designMode) return;
  try {
    
  class FurlySlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.furly-slider__track');
      this.slides = Array.from(this.querySelectorAll('.furly-slider__slide'));
      this.dots = Array.from(this.querySelectorAll('.furly-slider__dot'));
      this.index = 0;
      this.interval = parseInt(this.dataset.interval, 10) || 10000;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      for (const dot of this.dots) {
        dot.addEventListener('click', () => this.goTo(parseInt(dot.dataset.index, 10)));
      }
      this.querySelector('.furly-slider__arrow--prev')?.addEventListener('click', () => this.goTo(this.index - 1));
      this.querySelector('.furly-slider__arrow--next')?.addEventListener('click', () => this.goTo(this.index + 1));

      this.track.addEventListener('scroll', () => {
        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(() => {
          const i = Math.round(this.track.scrollLeft / this.track.clientWidth);
          if (i !== this.index) { this.index = i; this.paint(); }
        }, 80);
      });

      const stop = () => this.pause();
      const start = () => this.play();
      this.addEventListener('pointerenter', stop);
      this.addEventListener('pointerleave', start);
      this.addEventListener('focusin', stop);
      this.addEventListener('focusout', start);
      this.track.addEventListener('touchstart', stop, { passive: true });
      this.track.addEventListener('touchend', () => setTimeout(start, 4000), { passive: true });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) { this.pause(); } else { this.play(); }
      });

      this.paint();
      this.play();
    }

    disconnectedCallback() {
      this.pause();
    }

    play() {
      if (!this.hasAttribute('data-autoplay') || this.reducedMotion || this.slides.length < 2) return;
      this.pause();
      this.timer = setInterval(() => this.goTo(this.index + 1), this.interval);
    }

    pause() {
      clearInterval(this.timer);
    }

    goTo(i) {
      const count = this.slides.length;
      this.index = ((i % count) + count) % count;
      this.track.scrollTo({
        left: this.index * this.track.clientWidth,
        behavior: this.reducedMotion ? 'auto' : 'smooth'
      });
      this.paint();
    }

    paint() {
      this.dots.forEach((dot, i) => {
        dot.setAttribute('aria-selected', i === this.index ? 'true' : 'false');
      });
    }
  }

  if (!customElements.get('furly-slider')) {
    customElements.define('furly-slider', FurlySlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
